const actions = {
  setServiceAnnotationsModified(context, val) {
    context.commit('setServiceAnnotationsModified', val)
  }
}

export default actions
